import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { fetchBadges } from './actions';
import BadgeListPage from './BadgeListPage';
import Loading from '../common/components/Loading';

class Badges extends Component {
  componentDidMount() {
    const { dispatch, badgesLoaded } = this.props;

    if (!badgesLoaded) {
      dispatch(fetchBadges());
    }
  }
  render() {
    const { match, badgesLoaded } = this.props;

    if (!badgesLoaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={BadgeListPage} />
        <Redirect to={`${match.path}`} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    badgesLoaded: state.badges.badges.get('loaded'),
  };
};

export default connect(mapStateToProps)(Badges);



// WEBPACK FOOTER //
// ./src/badges/Badges.js